import { createAsyncThunk } from "@reduxjs/toolkit";
import { RootState } from "@/store/store";
import { getExplainWithAiSummaryByWidgetIdThunk } from "@/store/explain-with-ai/thunks/dashboard/getExplainWithAiSummaryByWidgetIdThunk";
import { explainWithAiWidgetIdSelector } from "@/store/explain-with-ai/selectors/slice-data/explainWithAiWidgetIdSelector";
import { isExplainWithAiOutDateRangesSelector } from "@/store/explain-with-ai/selectors/isExplainWithAiOutDateRangesSelector";
import { getBillingExplorerExplainWithAiSummaryThunk } from "@/store/explain-with-ai/thunks/billing-explorer/getBillingExplorerExplainWithAiSummaryThunk";

export const getExplainWithAiSummaryThunk = createAsyncThunk(
  "explainWithAi/getBillingExplorerSummary",
  async (_, { dispatch, getState }) => {
    const state = getState() as RootState;

    const widgetId = explainWithAiWidgetIdSelector(state);

    const isOutDateRanges = isExplainWithAiOutDateRangesSelector(state);
    if (isOutDateRanges) {
      return;
    }
    if (widgetId) {
      dispatch(getExplainWithAiSummaryByWidgetIdThunk(widgetId));
    } else {
      dispatch(getBillingExplorerExplainWithAiSummaryThunk());
    }
  },
);
